import axiosInstance from "../../common/interceptors/axiosInstance";
export interface LoginCredentials {
  email: string;
  password: string;
}
export interface UserAuthData {
  id: string;
  email: string;
  name: string;
  accessToken: string;
  firstName: "Admin";
  gender: string;
  isAdmin: true;
  lastName: "User";
  refreshToken?: string;
  roles: string[];
  status: string;
}
export interface LoginResponse {
  statusCode: number;
  message: string;
  data: UserAuthData;
}

interface AuthMessageResponse {
  data?: { msg?: string };
  message?: string;
}

const FORGOT_PASSWORD_OTP_TYPE = "FORGOT_PASSWORD";

export const loginAPI = async (
  credentials: LoginCredentials
): Promise<UserAuthData> => {
  const {data} = await axiosInstance.post<LoginResponse>(
    "/v1/auth/login/admin",
    credentials
  );
  return data.data;
};

export const requestPasswordResetAPI = async (email: string): Promise<void> => {
  await axiosInstance.post<AuthMessageResponse>("/v1/auth/forgot-password", {
    email,
    otpType: FORGOT_PASSWORD_OTP_TYPE,
  });
};

export const resendPasswordResetOtpAPI = async (email: string): Promise<void> => {
  await axiosInstance.post<AuthMessageResponse>("/v1/auth/resend-otp", {
    email,
    otpType: FORGOT_PASSWORD_OTP_TYPE,
  });
};

export const verifyPasswordResetOtpAPI = async (
  email: string,
  otp: number
): Promise<void> => {
  await axiosInstance.post<AuthMessageResponse>("/v1/auth/verify-otp", {
    email,
    otp,
    otpType: FORGOT_PASSWORD_OTP_TYPE,
  });
};

export const resetPasswordAPI = async (
  email: string,
  newPassword: string
): Promise<void> => {
  await axiosInstance.post<AuthMessageResponse>("/v1/auth/reset-password", {
    email,
    newPassword,
    otpType: FORGOT_PASSWORD_OTP_TYPE,
  });
};
